import { createEffect } from "solid-js";
import type { ServerMessage } from "@houston/shared";
import { createWebSocket } from "./createWebSocket.ts";
import { recordHealth, recordMetric } from "../stores/metrics.ts";
import { addDeploy } from "../stores/deploys.ts";
import { fireAlert, resolveAlert } from "../stores/alerts.ts";
import { pushMetric } from "../stores/streams.ts";
import { setConnected } from "../stores/connection.ts";

/**
 * Wires the WebSocket stream to the SolidJS stores. Each ServerMessage
 * variant is dispatched to the right store update function. This is the
 * single point where backend → frontend reactivity flows.
 */
export function createMetricStream() {
  const apiUrl = import.meta.env.VITE_HOUSTON_API_URL ?? "";
  const wsUrl = apiUrl.replace(/^http/, "ws") + "/ws";
  const { latest, connected } = createWebSocket(wsUrl);

  createEffect(() => {
    const msg = latest();
    if (!msg) return;
    dispatch(msg);
  });

  createEffect(() => setConnected(connected()));

  return { connected };
}

function dispatch(msg: ServerMessage) {
  switch (msg.type) {
    case "metric":
      recordMetric(msg.payload);
      pushMetric(msg.payload);
      break;
    case "metric-batch":
      for (const m of msg.payload) {
        recordMetric(m);
        pushMetric(m);
      }
      break;
    case "health":
      recordHealth(msg.payload);
      break;
    case "alert-fired":
      fireAlert(msg.payload);
      break;
    case "alert-resolved":
      resolveAlert(msg.payload.id, msg.payload.resolvedAt);
      break;
    case "deploy":
      addDeploy(msg.payload);
      break;
    case "hello":
    case "pong":
      break;
  }
}
